export enum ZoneModel {
  ADMIN = 'admin',
  PANEL = 'panel',
  WRITER = 'writer',
  WEB = 'web',
  API = 'api',
  AUTH = 'auth',
}